import { IHttpApi } from '@cian/http-api';
import { fetchAddFavorite, TAddFavoriteResponse } from '../../repositories/favorites/v1/add-favorite';
import { ResponseError } from '../../utils/errors';

export interface IAddNewbuildingToFavoritesParameters {
  /** ID ЖК **/
  newbuildingId: number;
}

export async function addNewbuildingToFavorites(httpApi: IHttpApi, parameters: IAddNewbuildingToFavoritesParameters) {
  const response: TAddFavoriteResponse = await fetchAddFavorite({
    httpApi,
    parameters: { entityId: parameters.newbuildingId, dealType: 'sale', entityType: 'newbuilding' },
  });

  if (response.statusCode !== 200) {
    const { errors, message } = response.response;

    throw new ResponseError({
      domain: 'shared/services/addNewbuildingToFavorites',
      message: 'Failed adding newbuilding to favorites',
      details: { errors: JSON.stringify(errors), message },
    });
  }

  return response.response;
}
